<div class="page-container" testId="point-audit-center-page">
  <div class="page-shell" testId="point-audit-center-shell">
    <section class="page-toolbar" testId="point-audit-center-toolbar">
      <div class="page-heading">
        <div class="title-row">
          <div class="title-copy">
            <h1 class="page-title">{{ 'point.audit.title' | i18n }}</h1>
            <p class="page-subtitle">{{ 'point.audit.subtitle' | i18n }}</p>
          </div>
          <div class="toolbar-actions">
            <button
              nz-button
              nzType="primary"
              type="button"
              class="refresh-btn"
              (click)="reload()"
              [nzLoading]="loading"
              testId="point-audit-center-refresh-button"
            >
              {{ 'common.refresh' | i18n }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="form-container">
      <div class="point-audit-page">
        <div class="page-top-panels">
          <div class="metric-grid" *ngIf="metrics.length">
            <nz-card
              class="metric-card"
              *ngFor="let metric of metrics"
              [class]="'tone-' + metric.tone"
              [testId]="'point-audit-center-metric-' + metric.key"
            >
              <div class="metric-card__head">
                <div class="metric-card__label" [testId]="'point-audit-center-metric-label-' + metric.key">{{
                  metric.labelKey | i18n
                }}</div>
                <span class="metric-card__spark" [class]="'tone-' + metric.tone"></span>
              </div>
              <div class="metric-card__value" [testId]="'point-audit-center-metric-value-' + metric.key">{{ metric.value }}</div>
            </nz-card>
          </div>

          <nz-card class="filter-card" testId="point-audit-center-filter-card">
            <div class="filter-grid">
              <label class="filter-field filter-field--search">
                <span class="sr-only">{{ 'point.audit.filter.keyword.placeholder' | i18n }}</span>
                <nz-input-group [nzPrefix]="searchPrefix">
                  <input
                    nz-input
                    [(ngModel)]="searchKeyword"
                    (keyup.enter)="search()"
                    [placeholder]="'point.audit.filter.keyword.placeholder' | i18n"
                    testId="point-audit-center-search-input"
                  />
                </nz-input-group>
                <ng-template #searchPrefix>
                  <span class="search-prefix"></span>
                </ng-template>
              </label>

              <div class="filter-field filter-field--scene">
                <nz-select
                  [(ngModel)]="selectedScene"
                  (ngModelChange)="onSceneFilterChange($event)"
                  [nzAllowClear]="true"
                  [nzPlaceHolder]="'point.audit.filter.scene.all' | i18n"
                  testId="point-audit-center-scene-select"
                >
                  <nz-option *ngFor="let option of sceneOptions" [nzValue]="option.value" [nzLabel]="option.label" />
                </nz-select>
              </div>

              <div class="filter-field filter-field--status">
                <nz-select
                  [(ngModel)]="selectedStatus"
                  (ngModelChange)="onStatusFilterChange($event)"
                  [nzAllowClear]="true"
                  [nzPlaceHolder]="'point.audit.filter.status.all' | i18n"
                  testId="point-audit-center-status-select"
                >
                  <nz-option *ngFor="let option of statusOptions" [nzValue]="option.value" [nzLabel]="option.label" />
                </nz-select>
              </div>

              <label class="filter-field filter-field--operator">
                <input
                  nz-input
                  [(ngModel)]="operatorKeyword"
                  (keyup.enter)="search()"
                  [placeholder]="'point.audit.filter.operator.placeholder' | i18n"
                  testId="point-audit-center-operator-input"
                />
              </label>

              <label class="filter-field filter-field--source">
                <input
                  nz-input
                  [(ngModel)]="sourceBizIdKeyword"
                  (keyup.enter)="search()"
                  [placeholder]="'point.audit.filter.source-biz-id.placeholder' | i18n"
                  testId="point-audit-center-source-biz-id-input"
                />
              </label>

              <div class="filter-actions">
                <button nz-button nzType="primary" type="button" (click)="search()" testId="point-audit-center-search-button">
                  {{ 'common.search' | i18n }}
                </button>
                <button nz-button type="button" (click)="resetFilters()" testId="point-audit-center-reset-button">
                  {{ 'common.reset' | i18n }}
                </button>
              </div>
            </div>
          </nz-card>
        </div>

        <nz-card class="table-card" testId="point-audit-center-table-card">
          <nz-spin [nzSpinning]="loading || recordsLoading" testId="point-audit-center-spin">
            <div class="table-scroll-region">
              <ng-container *ngIf="records.length; else emptyTpl">
                <div class="point-audit-table">
                  <div class="point-audit-table__header">
                    <div>{{ 'point.audit.table.time' | i18n }}</div>
                    <div>{{ 'point.audit.table.tenant' | i18n }}</div>
                    <div>{{ 'point.audit.table.scene' | i18n }}</div>
                    <div>{{ 'point.audit.table.status' | i18n }}</div>
                    <div>{{ 'point.audit.table.reason' | i18n }}</div>
                    <div>{{ 'point.audit.table.amount' | i18n }}</div>
                    <div>{{ 'common.actions' | i18n }}</div>
                  </div>

                  <div
                    class="point-audit-table__row"
                    *ngFor="let record of records; let i = index"
                    [testId]="'point-audit-center-row-' + i"
                  >
                    <div [attr.data-label]="'point.audit.table.time' | i18n">{{ formatDateTime(record.time) }}</div>
                    <div [attr.data-label]="'point.audit.table.tenant' | i18n" class="tenant-cell">
                      <strong>{{ record.tenantName }}</strong>
                      <span>{{ record.tenantId }}</span>
                    </div>
                    <div [attr.data-label]="'point.audit.table.scene' | i18n">{{ record.sceneLabel }}</div>
                    <div [attr.data-label]="'point.audit.table.status' | i18n">
                      <nz-tag class="audit-status-tag" [ngClass]="getStatusClass(record.statusKey)">{{ record.statusLabel }}</nz-tag>
                    </div>
                    <div [attr.data-label]="'point.audit.table.reason' | i18n" class="reason-cell" [title]="record.reason">
                      {{ record.reason }}
                    </div>
                    <div [attr.data-label]="'point.audit.table.amount' | i18n" class="amount-cell" [class]="getAmountClass(record.amount)">
                      {{ formatSignedNumber(record.amount) }}
                    </div>
                    <div [attr.data-label]="'common.actions' | i18n" class="action-cell">
                      <button
                        nz-button
                        type="button"
                        class="row-view-btn"
                        (click)="openDetail(record)"
                        [testId]="'point-audit-center-view-button-' + i"
                      >
                        {{ 'common.view' | i18n }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="table-footer">
                  <div class="table-total">{{ 'common.total-records' | i18n: { total: total } }}</div>
                  <nz-pagination
                    nzSize="small"
                    [nzPageIndex]="pageIndex"
                    [nzPageSize]="pageSize"
                    [nzTotal]="total"
                    [nzShowQuickJumper]="true"
                    [nzShowSizeChanger]="true"
                    [nzPageSizeOptions]="[10, 20, 50, 100]"
                    (nzPageIndexChange)="onPageIndexChange($event)"
                    (nzPageSizeChange)="onPageSizeChange($event)"
                    testId="point-audit-center-pagination"
                  />
                </div>
              </ng-container>
            </div>
          </nz-spin>

          <ng-template #emptyTpl>
            <div class="empty-state">
              <div class="empty-state__art" aria-hidden="true">
                <span class="empty-state__sheet"></span>
                <span class="empty-state__bubble"></span>
              </div>
              <div class="empty-state__text">{{ 'point.audit.empty' | i18n }}</div>
            </div>
          </ng-template>
        </nz-card>
      </div>
    </div>
  </div>
</div>

<nz-drawer
  [nzVisible]="detailVisible"
  [nzTitle]="'point.audit.detail.title' | i18n"
  [nzWidth]="520"
  (nzOnClose)="closeDetail()"
  testId="point-audit-center-detail-drawer"
>
  <ng-container *nzDrawerContent>
    <div class="detail-panel" *ngIf="selectedRecord as record">
      <div class="detail-group" testId="point-audit-center-detail-group">
        <div class="detail-row" testId="point-audit-center-detail-row-time">
          <span class="detail-row__label">{{ 'point.audit.table.time' | i18n }}</span>
          <strong class="detail-row__value" testId="point-audit-center-detail-value-time">{{ formatDateTime(record.time) }}</strong>
        </div>
        <div class="detail-row" testId="point-audit-center-detail-row-tenant">
          <span class="detail-row__label">{{ 'point.audit.table.tenant' | i18n }}</span>
          <strong class="detail-row__value" testId="point-audit-center-detail-value-tenant">{{ record.tenantName }}</strong>
        </div>
        <div class="detail-row" testId="point-audit-center-detail-row-open-id">
          <span class="detail-row__label">{{ 'point.audit.detail.open-id' | i18n }}</span>
          <strong class="detail-row__value" testId="point-audit-center-detail-value-open-id">{{ record.openId }}</strong>
        </div>
        <div class="detail-row" testId="point-audit-center-detail-row-scene">
          <span class="detail-row__label">{{ 'point.audit.table.scene' | i18n }}</span>
          <strong class="detail-row__value" testId="point-audit-center-detail-value-scene">{{ record.sceneLabel }}</strong>
        </div>
        <div class="detail-row" testId="point-audit-center-detail-row-status">
          <span class="detail-row__label">{{ 'point.audit.table.status' | i18n }}</span>
          <strong class="detail-row__value" testId="point-audit-center-detail-value-status">{{ record.statusLabel }}</strong>
        </div>
        <div class="detail-row" testId="point-audit-center-detail-row-amount">
          <span class="detail-row__label">{{ 'point.audit.table.amount' | i18n }}</span>
          <strong class="detail-row__value" [class]="getAmountClass(record.amount)" testId="point-audit-center-detail-value-amount">{{
            formatSignedNumber(record.amount)
          }}</strong>
        </div>
        <div class="detail-row" testId="point-audit-center-detail-row-event-id">
          <span class="detail-row__label">{{ 'point.audit.detail.event-id' | i18n }}</span>
          <strong class="detail-row__value" testId="point-audit-center-detail-value-event-id">{{ record.eventId }}</strong>
        </div>
        <div class="detail-row" testId="point-audit-center-detail-row-operator">
          <span class="detail-row__label">{{ 'point.audit.detail.operator' | i18n }}</span>
          <strong class="detail-row__value" testId="point-audit-center-detail-value-operator">{{ record.operatorName }}</strong>
        </div>
        <div class="detail-row" testId="point-audit-center-detail-row-source-biz-id">
          <span class="detail-row__label">{{ 'point.audit.detail.source-biz-id' | i18n }}</span>
          <strong class="detail-row__value" testId="point-audit-center-detail-value-source-biz-id">{{ record.sourceBizId }}</strong>
        </div>
      </div>

      <div class="detail-section" testId="point-audit-center-detail-reason-section">
        <h3 testId="point-audit-center-detail-reason-title">{{ 'point.audit.table.reason' | i18n }}</h3>
        <p testId="point-audit-center-detail-reason-value">{{ record.reason }}</p>
      </div>

      <div class="detail-section" testId="point-audit-center-detail-raw-section">
        <h3 testId="point-audit-center-detail-raw-title">{{ 'point.audit.detail.raw-data' | i18n }}</h3>
        <div class="raw-grid">
          <div
            class="raw-row"
            *ngFor="let item of objectEntries(record.raw); let rawIndex = index"
            [testId]="'point-audit-center-detail-raw-row-' + rawIndex"
          >
            <span [testId]="'point-audit-center-detail-raw-key-' + rawIndex">{{ item.key }}</span>
            <code [testId]="'point-audit-center-detail-raw-value-' + rawIndex">{{ item.value }}</code>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-drawer>
